import { useCallback, useContext } from "react";
import {
  Board,
  BoardMachinesStates,
  quoteLoaded,
  QuoteState,
  updateQuoteState,
} from "../../../../../reducers/uploadedBoard";
import { useRefreshBoardInStore } from "../boardRefreshes";
import { useAppDispatch } from "../../../store";
import { BoardIdContext, BoardShipmentIds } from "./reviewBoardFlowLoader";

export default function useRefreshQuote() {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const dispatch = useAppDispatch();
  const updateQuote = useCallback(
    (board: Board) => {
      dispatch(quoteLoaded({ board }));
    },
    [dispatch],
  );
  const { refreshBoard: refreshQuote } = useRefreshBoardInStore(updateQuote);
  const { refreshBoard } = useRefreshBoardInStore();

  const handleQuoteStateUpdates = useCallback(
    (nextStatesData: BoardMachinesStates, states: BoardMachinesStates) => {
      if (
        states.quote_state != QuoteState.QUOTED &&
        nextStatesData.quote_state == QuoteState.QUOTED
      ) {
        refreshQuote();
      } else if (
        states.quote_state != QuoteState.ORDER_RECEIVED &&
        nextStatesData.quote_state == QuoteState.ORDER_RECEIVED
      ) {
        refreshBoard();
      } else if (boardId) {
        dispatch(
          updateQuoteState({ boardId, quoteState: nextStatesData.quote_state }),
        );
      }
    },
    [boardId, refreshQuote, refreshBoard, dispatch],
  );

  return {
    refreshQuote,
    handleQuoteStateUpdates,
  };
}
